<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <div class="Info_Area">
      <b-container fluid>
        <b-row>
          <b-col>
            <!-- <b-row>
              <div class="container-fluid">
                <div class="index-top-info">
                  <form class="form-inline">
                    <span>年度</span>
                    <b-form-select v-model="ricefarm.yearselected" :options="ricefarm.yearoptions"></b-form-select>
                    <span>期作</span>
                    <b-form-select v-model="ricefarm.periodselected" :options="ricefarm.periodoptions"></b-form-select>
                    <b-button @click="filteritems" variant="warning">查詢</b-button>
                    <b-button @click="$router.push({ path: '/databuildaddforricefarm/add' })" variant="success">新增</b-button>
                    <export-excel
                        :data="exceldata.dataset"
                        :fields="exceldata.fields"
                        :worksheet="exceldata.filename"
                        :name="exceldata.filename + getNow()">
                      <b-button style="padding-right: 10px;" variant="success">匯出</b-button>
                    </export-excel>
                  </form>
                </div>
              </div>
            </b-row> -->
            <b-row>
              <b-col>
                <!-- <b-button
                  v-if="showmanage.add"
                  @click="
                    $router.push({ path: '/databuildaddforricefarm/add' })
                  "
                  variant="warning"
                  >新增價格</b-button
                > -->
              </b-col>
              <b-col cols="auto" style="display: inline-flex;">
                <label style="margin-right: 0.5rem;">
                  <label for="file" class="btn btn-success">匯入</label>
                  <input
                    @change="uploadFile"
                    id="file"
                    type="file"
                    style="display: none;"
                  />
                </label>
                <export-excel
                  :data="exceldata.dataset"
                  :fields="exceldata.fields"
                  :worksheet="exceldata.filename"
                  :name="exceldata.filename + getNow()"
                >
                  <b-button
                    style="padding-right: 10px;margin-right: 0.5rem;"
                    variant="warning"
                    >匯出</b-button
                  >
                </export-excel>
                <a
                  href="https://agri-data.cyhg.gov.tw/uplode/112%e7%a8%bb%e7%a9%80%e6%94%b6%e8%b3%bc%e5%83%b9%e6%a0%bc%e5%8f%8a%e5%88%88%e6%95%b8%e8%a1%a8-%e8%b3%87%e6%96%99%e5%8c%af%e5%85%a5%e7%af%84%e6%9c%ac.xlsx"
                  download="稻穀收購價格及刈數表範本檔案.xlsx"
                >
                  <b-button>範本下載</b-button>
                </a>
              </b-col>
            </b-row>
            <b-row>
              <div class="container-fluid">
                <div class="index-top-info">
                  <b-form inline>
                    <b-input-group>
                      <label
                        class="sr-only"
                        for="inline-form-input-name"
                      ></label>
                      <b-input-group-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-text>
                      <datepicker
                        v-model="timepicker.minvalue"
                        min="1960-01-01"
                        :max="twtimeparse(timepicker.maxvalue)"
                      ></datepicker>
                    </b-input-group>
                    <span>~</span>
                    <b-input-group style="margin-right: 0.5rem;">
                      <label
                        class="sr-only"
                        for="inline-form-input-name"
                      ></label>
                      <b-input-group-text>
                        <b-icon icon="calendar3"></b-icon>
                      </b-input-group-text>
                      <datepicker
                        v-model="timepicker.maxvalue"
                        :min="twtimeparse(timepicker.minvalue)"
                        :max="timepicker.max"
                      ></datepicker>
                    </b-input-group>
                    <b-button
                      @click="getRiceFarmManagementList"
                      variant="warning"
                      >查詢</b-button
                    >
                  </b-form>
                </div>
              </div>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <b-table
              :items="priceanalysis.items"
              :fields="priceanalysis.fields"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              :stacked="window.width < 1024"
              striped
              bordered
              outlined
              hover
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #thead-top head-variant="dark">
                <b-tr class="thead-dark">
                  <b-th>日期</b-th>
                  <b-th>期作</b-th>
                  <b-th>鄉鎮別</b-th>
                  <b-th>收購單位</b-th>
                  <b-th>今日<br />收購量(噸)含公糧及自營糧</b-th>
                  <b-th>累加<br />收購量(噸)含公糧及自營糧</b-th>
                  <!-- <b-th colspan="2">濕度</b-th>
                  <b-th colspan="2">刈數(1刈=100台斤/分)</b-th>
                  <b-th colspan="2">價格(價格)</b-th> -->
                  <b-th>低濕度</b-th>
                  <b-th>高濕度</b-th>
                  <b-th>低刈數(每分地)</b-th>
                  <b-th>高刈數(每分地)</b-th>
                  <b-th>低價格(元/每百台斤)</b-th>
                  <b-th>高價格(元/每百台斤)</b-th>
                  <b-th>收割比例(%)</b-th>
                  <b-th>備註</b-th>
                  <!-- <b-th>操作</b-th> -->
                </b-tr>
              </template>
              <!-- <template #cell(RF_PERIOD)="data">
                <div>
                  {{data.item.RF_PERIOD == "001" ? "第一期" : "第二期"}}
                </div>
              </template> -->
              <template #cell(EDIT)="data">
                <b-button
                  v-if="showmanage.edit"
                  style="margin-right: 0.3rem;"
                  @click="changePage(data)"
                  variant="warning"
                  >編輯</b-button
                >
                <b-button variant="danger">刪除</b-button>
              </template>
              <template #cell(SUM)="data">
                <div
                  v-if="data.item.SUM != 0"
                  v-b-tooltip.hover
                  :title="data.item.ALLSUM"
                >
                  {{ data.item.SUM }}
                </div>
              </template>

              <template #cell()="data">
                {{ data.value == 0 ? "" : data.value }}
              </template>
            </b-table>
            <b-pagination
              v-show="totalRows > perPage"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="companyList"
              align="center"
            >
            </b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-container>
</template>
<script>
import datepicker from "@/components/Datepicker.vue";

export default {
  data() {
    var date = new Date();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    const minDate = new Date(today);
    minDate.setDate(date.getDate() - 7);
    var taiwanMinDate = minDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMinDate[0] = parseInt(taiwanMinDate[0]) - 1911;
    taiwanMinDate[1] =
      taiwanMinDate[1].length == 1 ? 0 + taiwanMinDate[1] : taiwanMinDate[1];
    taiwanMinDate[2] =
      taiwanMinDate[2].length == 1 ? 0 + taiwanMinDate[2] : taiwanMinDate[2];
    var taiwanMaxDate = maxDate
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      perPage: 10,
      currentPage: 1,
      filterSearch: null,
      selection: [],
      totalRows: 1,
      isBusy: false,
      timepicker: {
        minvalue: taiwanMinDate.join("-"),
        maxvalue: taiwanMaxDate.join("-"),
        // minvalue: "110-06-06",
        // maxvalue: "110-06-10",
        max: maxDate
          .toLocaleString()
          .split(" ")[0]
          .split("/")
          .join("-"),
      },
      window: {
        width: 1024,
        height: 0,
      },
      // countrysortedlist: [
      //   "太保市",
      //   "朴子市",
      //   "布袋鎮",
      //   "大林鎮",
      //   "民雄鄉",
      //   "溪口鄉",
      //   "新港鄉",
      //   "六腳鄉",
      //   "東石鄉",
      //   "義竹鄉",
      //   "鹿草鄉",
      //   "水上鄉",
      //   "中埔鄉",
      //   "竹崎鄉",
      //   "梅山鄉",
      //   "番路鄉",
      //   "大埔鄉",
      //   "阿里山鄉",
      // ],
      countrysortedlist: [
        "水上鄉",
        "鹿草鄉",
        "布袋鎮",
        "義竹鄉",
        "太保市",
        "新港鄉",
        "溪口鄉",
        "大林鎮",
        "民雄鄉",
        "朴子市",
        "六腳鄉",
        "東石鄉",
        "中埔鄉",
        "竹崎鄉",
      ],
      companysortedlist: [
        "水上鄉農會",
        "順利糧食有限公司",
        "鹿草鄉農會",
        "三合豐碾米廠分廠",
        "玉豐糧食股份有限公司(布袋合成碾米工廠)",
        "太保市農會",
        "新港鄉農會",
        "久長碾米工廠",
        "東興糧食工廠",
        "溪口鄉農會",
        "永昌碾米工廠",
        "大林鎮農會",
        "新聯豐碾米工廠",
        "豐益糧食公司",
        "民雄鄉農會",
        "和泰碾米工廠",
        "朴子市農會",
      ],
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "稻作價格維護",
          active: true,
        },
      ],
      exceldata: {
        fields: {
          日期: "RF_CDATE",
          期作: "RF_PERIOD",
          鄉鎮別: "RF_TOWN",
          收購單位: "RF_UNIT",
          "今日收購量(噸)含公糧及自營糧": "RF_VOLUME",
          "累加收購量(噸)含公糧及自營糧": "SUM",
          "累加收購量(噸)含公糧及自營糧細項": "ALLSUM",
          低濕度: "RF_HUM_L",
          高濕度: "RF_HUM_H",
          "低刈數(每分地)": "RF_MOW_L",
          "高刈數(每分地)": "RF_MOW_H",
          "低價格(元/每百台斤)": "RF_PRICE_L",
          "高價格(元/每百台斤)": "RF_PRICE_H",
          "收割比例(%)": "RF_RATIO",
          備註: "RF_NOTE",
        },
        dataset: [],
        filename: "稻作管理清單",
      },
      priceanalysis: {
        fields: [
          {
            key: "RF_CDATE",
            label: "日期",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_PERIOD",
            label: "期作",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_TOWN",
            label: "鄉鎮別",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_UNIT",
            label: "收購單位",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_VOLUME",
            label: "今日收購量(噸)含公糧及自營糧",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "SUM",
            label: "累加收購量(噸)含公糧及自營糧",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_HUM_L",
            label: "低濕度",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_HUM_H",
            label: "高濕度",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_MOW_L",
            label: "低刈數(每分地)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_MOW_H",
            label: "高刈數(每分地)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_PRICE_L",
            label: "低價格(元/每百台斤)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_PRICE_H",
            label: "高價格(元/每百台斤)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_RATIO",
            label: "收割比例(%)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "RF_NOTE",
            label: "備註",
            thClass: "hideheadr",
            visible: true,
          },
          // {
          //   key: "EDIT",
          //   label: "操作",
          //   thClass: "hideheadr",
          //   visible: true,
          // },
        ],
        allitems: [
          {
            DATE: "110-06-09",
            PEROID: "001",
            TOWNCATEGORY: "水上鄉",
            PURCHASEUNIT: "水上鄉農會",
            PURCHASE: "282",
            MINWET: 26,
            MAXWET: 27,
            MINYIELD: 20,
            MAXYIELD: 20,
            MINPRICE: 1000,
            MAXPRICE: 1000,
          },
          {
            DATE: "110-06-09",
            PEROID: "001",
            TOWNCATEGORY: "水上鄉",
            PURCHASEUNIT: "順利糧食有限公司",
            PURCHASE: "505",
            MINWET: 26,
            MAXWET: 30,
            MINYIELD: 17,
            MAXYIELD: 20,
            MINPRICE: 980,
            MAXPRICE: 1020,
          },
          {
            DATE: "110-06-08",
            PEROID: "001",
            TOWNCATEGORY: "水上鄉",
            PURCHASEUNIT: "水上鄉農會",
            PURCHASE: "237",
            MINWET: 26,
            MAXWET: 27,
            MINYIELD: 22,
            MAXYIELD: 22,
            MINPRICE: 1000,
            MAXPRICE: 1030,
          },
          {
            DATE: "110-06-08",
            PEROID: "001",
            TOWNCATEGORY: "水上鄉",
            PURCHASEUNIT: "順利糧食有限公司",
            PURCHASE: "385",
            MINWET: 26,
            MAXWET: 30,
            MINYIELD: 17,
            MAXYIELD: 20,
            MINPRICE: 980,
            MAXPRICE: 1020,
          },
          {
            DATE: "109-11-26",
            PEROID: "002",
            TOWNCATEGORY: "水上鄉",
            PURCHASEUNIT: "順利糧食有限公司",
            PURCHASE: "73",
            MINWET: 25,
            MAXWET: 25,
            MINYIELD: 13,
            MAXYIELD: 13,
            MINPRICE: 940,
            MAXPRICE: 940,
          },
          {
            DATE: "109-11-26",
            PEROID: "002",
            TOWNCATEGORY: "民雄鄉",
            PURCHASEUNIT: "民雄鄉農會",
            PURCHASE: "1010",
            MINWET: 27,
            MAXWET: 28,
            MINYIELD: 0,
            MAXYIELD: 0,
            MINPRICE: 1010,
            MAXPRICE: 1010,
          },
        ],
        items: [],
        additem: {},
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      ricefarm: {
        yearoptions: ["110", "109"],
        periodoptions: [
          { text: "第一期", value: "001" },
          { text: "第二期", value: "002" },
        ],
        yearselected: "110",
        periodselected: "001",
      },
      showmanage: {
        show: false,
        add: false,
        edit: false,
        delete: false,
        count: 0,
      },
      apiRiceFarmManagementList: (data) =>
        this.userRequest.post("/API/Default/RiceFarmManagementList", data),
      apiRiceFarmExcelUpload: (data) =>
        this.userRequest.post("/API/Default/RiceFarmExcelUpload", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
    };
  },
  created() {
    this.checkLogin();
    // this.init();
  },
  mounted() {
    // this.checkLogin()
    // this.checkPermission()
  },
  components: {
    datepicker,
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.showmanage.count = 0;
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000018",
        fun: this.checkByPJIDshow,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000019",
        fun: this.checkByPJIDadd,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000020",
        fun: this.checkByPJIDedit,
      });
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    // checkByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.$router.push({ path: "/" });
    //   } else {
    //     // window.addEventListener("resize", this.handleResize);
    //     // this.handleResize();
    //     this.init();
    //   }
    // },
    //  checkLogin() {
    //     let TokenID = sessionStorage.getItem("TokenID");
    //     if(TokenID){
    //         this.checkPermission()
    //     }
    //     else
    //     {
    //         alert("無權限檢視此頁面，請登入帳號")
    //         this.$router.push({ path: '/login' })
    //     }
    // },
    checkallpermission() {
      if (this.showmanage.show || this.showmanage.add || this.showmanage.edit) {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        this.init();
      } else {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      }
    },
    checkByPJIDshow(value) {
      this.showmanage.count++;
      if (value) this.showmanage.show = true;
    },
    checkByPJIDadd(value) {
      this.showmanage.count++;
      if (value) this.showmanage.add = true;
    },
    checkByPJIDedit(value) {
      this.showmanage.count++;
      if (value) this.showmanage.edit = true;
    },
    checkByPJIDdelete(value) {
      this.showmanage.count++;
      if (value) this.showmanage.delete = true;
    },
    getRiceFarmManagementList() {
      this.isBusy = true;

      let localmintime = this.timepicker.minvalue.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let localmaxtime = this.timepicker.maxvalue.split("-");
      localmaxtime[0] = parseInt(localmaxtime[0]) + 1911;

      let obj = {
        start_date: localmintime.join("-"),
        end_date: localmaxtime.join("-"),
      };
      this.FunctionToken(this.riceFarmManagementList, obj);
    },
    riceFarmManagementList(data) {
      this.apiRiceFarmManagementList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.priceanalysis.items = [];
            this.exceldata.dataset = [];
            let dataItems = JSON.parse(json.Data);
            dataItems.forEach((z) => {
              z.index =
                this.countrysortedlist.indexOf(z.RF_TOWN) == -1
                  ? 99
                  : this.countrysortedlist.indexOf(z.RF_TOWN);
              z.comapnyindex =
                this.companysortedlist.indexOf(z.RF_UNIT) == -1
                  ? 99
                  : this.companysortedlist.indexOf(z.RF_UNIT);
              z.RF_UNIT = z.RF_UNIT == 0 ? "" : z.RF_UNIT;
            });
            console.log(dataItems);
            if (dataItems.length != 0) {
              dataItems.sort((a, b) => {
                return a.RF_CDATE == b.RF_CDATE
                  ? this.compareCountryList(a, b)
                  : (a.RF_CDATE < b.RF_CDATE) - (a.RF_CDATE > b.RF_CDATE);
              });
              for (let i in dataItems) {
                let subitem = dataItems[i];
                let sumlist2 = subitem.RF_VOLUME_SUM.split(",");
                let sum = 0;
                let sumlist1 = sumlist2.filter((y) => y != "");
                sumlist1.forEach((x) => {
                  if (
                    x != "" &&
                    x != null &&
                    x != 0 &&
                    x != undefined &&
                    x != "undefined"
                  )
                    sum += parseInt(x);
                });
                subitem["SUM"] = sum;
                subitem["ALLSUM"] = sumlist1.join("+");
                let datetime1 = subitem.RF_CDATE.split("T")[0].split("-");
                datetime1[0] = parseInt(datetime1[0]) - 1911;
                subitem.RF_CDATE = datetime1.join("-");
                subitem.RF_PERIOD =
                  subitem.RF_PERIOD == "001" ? "第一期" : "第二期";
                this.exceldata.dataset.push(subitem);
              }
              this.priceanalysis.items = dataItems;
              this.exceldata.dataset.forEach((z) => {
                if (z.SUM == 0) z.ALLSUM = 0;
              });

              if (this.timepicker.minvalue == this.timepicker.maxvalue)
                this.perPage = this.priceanalysis.items.length;
              else this.perPage = 10;
              // this.exceldata.dataset = dataItems
              // this.totalRows = dataItems.length;
            }
            this.isBusy = false;
          }
        })
        .catch((err) => console.warn(err));
    },
    init() {
      this.getRiceFarmManagementList();
    },
    twtimeparse(item) {
      let tt = item.split("-");
      tt[0] = parseInt(tt[0]) + 1911;
      return tt.join("-");
    },
    compareCountryList(a, b) {
      return a.index == b.index
        ? a.comapnyindex - b.comapnyindex
        : a.index - b.index;
    },
    // filteritems() {
    //   this.priceanalysis.items = []
    // },
    // async checkPermission() {
    //   let accountdata = { PJ_ID: "PJ000000000014", fun: this.checkshowByPJID };
    //   this.FunctionToken(this.Authority, accountdata);
    //   let databuilddata = {
    //     PJ_ID: "PJ000000000015",
    //     fun: this.checkeditdataByPJID,
    //   };
    //   this.FunctionToken(this.Authority, databuilddata);
    // },
    // checkshowByPJID(value) {
    //   if (!value) {
    //     alert("無權限檢視此頁面，將返回首頁");
    //     this.datamanagement.ifshow = false;
    //     this.$router.push({ path: "/" });
    //   } else {
    //     this.datamanagement.ifshow = true;
    //     this.FunctionToken(this.getTradeWarningCrop, {});
    //     this.settotalRows();
    //   }
    // },
    // checkeditdataByPJID(value) {
    //   if (!value) {
    //     this.datamanagement.ifedit = false;
    //   } else {
    //     this.datamanagement.ifedit = true;
    //   }
    // },
    getNow: function() {
      const today = new Date();
      const date =
        today.getFullYear() +
        "" +
        (today.getMonth() + 1) +
        "" +
        today.getDate();
      const time =
        today.getHours() + "" + today.getMinutes() + "" + today.getSeconds();
      const dateTime = date + "" + time;
      return "-" + dateTime;
    },
    changePage(item) {
      let value = item.item.DATE.split("/").join("-");
      this.$router.push({
        name: "DataBuildAddForRiceFarm",
        params: { id: value },
      });
    },
    settotalRows() {
      this.totalRows = this.priceanalysis.items.length;
    },
    // onFiltered(filteredItems) {
    //   // Trigger pagination to update the number of buttons/pages due to filtering
    //   this.totalRows = filteredItems.length;
    //   this.currentPage = 1;
    // },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
    uploadFile(e) {
      const file = e.target.files[0];
      const inputEl = e.target;
      if (!file) return;

      const fileName = file.name || "";
      const fileType = file.type || "";
      const ext = fileName.includes(".")
        ? fileName.split(".").pop().toLowerCase()
        : "";
      const allowedExt = ["xls", "xlsx"];
      const allowedMimeTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (!allowedExt.includes(ext) && !allowedMimeTypes.includes(fileType)) {
        alert("僅允許上傳 xls、xlsx 檔案");
        inputEl.value = "";
        return;
      }
      console.log(file);
      let formdata = new FormData();
      formdata.append("Files", file);
      // this.$axios.post('API/Default/Post',formdata)
      this.apiRiceFarmExcelUpload(formdata)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsonData = JSON.parse(json.Data);
            console.log(jsonData);
            alert("上傳成功");
            this.$router.go();
            //success(jsonData.SP_PATH+jsonData.MC_FILE);
          } else {
            console.warn("上傳失敗");
          }
        });
    },
  },
  watch: {
    "priceanalysis.items"() {
      this.settotalRows();
    },
    "showmanage.count"(val) {
      if (val == 3) {
        this.checkallpermission();
      }
    },
  },
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
</style>
